import { memo } from 'react';

import BreadcrumbsContainer from '@/components/atomic/templates/navigation/breadcrumbs/components/container';
import BreadcrumbsList from '@/components/atomic/templates/navigation/breadcrumbs/components/list';
import useBreadcrumbs from '@/components/atomic/templates/navigation/breadcrumbs/hooks/use-breadcrumbs';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import getCanShowSecondaryNav from '@/state/selectors/secondary-nav/get-can-show-secondary-nav';
import { BasicComponentProps } from '@/typings/generic';

const BreadcrumbsComponent = ({ $exposerSuffix }: BasicComponentProps) => {
	const canRender = useStore(getCanShowSecondaryNav);

	useBreadcrumbs();

	if (!canRender) return null;

	return (
		<BreadcrumbsContainer>
			<BreadcrumbsList $exposerSuffix={$exposerSuffix} />
		</BreadcrumbsContainer>
	);
};

const Breadcrumbs = memo(withExposer(BreadcrumbsComponent, 'breadcrumbs'));

export default Breadcrumbs;
